import React from "react";

import {
  Paper,
  Tooltip,
  IconButton,
  Input,
  Typography,
  Button,
  Popover,
  Breadcrumbs,
} from "@mui/material";

import {
  Publish as PublishIcon,
  Delete as DeleteIcon,
  CreateNewFolder as CreateNewFolderIcon,
  Refresh as RefreshIcon,
  Home as HomeIcon,
  NavigateNext,
  FileCopy,
  AssignmentTurnedIn,
} from "@mui/icons-material";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Wrapper } from "components";
import "./style.css";
import UploadImageDialog from "./EditImageDialog";

import { UPLOADED_MEDIA_URL } from "constants/serverUrl";

import FileBrowser from "./fileBrowser";
import SplitPane from "react-split-pane";
import FileDetailPanel from "./detailPanel";
import {
  getFileCredit,
  listDirectory,
  uploadFile,
  deleteEntry,
  createDirectory,
} from "./utils";

class mediaLibraryTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dir: localStorage.getItem("mediaLibrary_path"),
      selectedEntry: null,
      filterFilename: "",
      newFolderName: "New Folder",
      anchorNewFolder: null,
      anchorDeleteEntry: null,
      newFilename: "",
      metadata: {
        loading: false,
        credit: "",
      },
    };
  }

  getDirectoryEntries = (dir) => {
    this.setState({ loading: true });
    listDirectory(dir, (res) => {
      if (!res) {
        this.setState({ loading: false, err: true });
        return;
      }

      localStorage.setItem("mediaLibrary_path", res.dir ? res.dir : "");
      this.setState({
        loading: false,
        err: null,
        dir: res.dir,
        entries: res.entries,
      });
    });
  };

  componentDidMount = () => {
    this.getDirectoryEntries(this.state.dir);
  };

  getFileMetadata = (filename) => {
    this.setState({ metadata: { loading: true, credit: "" } });
    getFileCredit(filename, (credit) =>
      this.setState({ loading: false, credit })
    );
  };

  handleBulkUpload = async (files) => {
    if (!files || files.length < 1) return;
    const { dir } = this.state;
    this.setState({ uploading: true, uploadingErr: -1 });
    for (var i = 0; i < files.length; i++) {
      let res = await uploadFile(files[i], dir, files[i].name);
      console.log(res);
      if (!res) {
        this.setState({ uploading: false, uploadingErr: 1 });
      }
    }

    this.setState({ uploading: false, uploadingErr: 0 });
    this.getDirectoryEntries(this.state.dir);
  };

  handleUpload = async (file, filename, compressionOption, credit) => {
    const { dir } = this.state;
    this.setState({ uploading: true, uploadingErr: -1 });
    let res = await uploadFile(file, dir, filename, compressionOption);
    console.log(res);
    if (!res) {
      this.setState({ uploading: false, uploadingErr: 1 });
    }

    this.setState({ uploading: false, uploadingErr: 0 });
    this.getDirectoryEntries(this.state.dir);
  };

  handleCopyPaste = async () => {
    const { copyTasks } = this.state;
    if (!Array.isArray(copyTasks)) return;

    this.setState({ uploading: true, uploadingErr: null });
    for (var path of copyTasks) {
      console.log(path);
      let blob = await fetch(`${UPLOADED_MEDIA_URL}${path}`).then((r) =>
        r.blob()
      );
      let file = blob;
      file.lastModifiedDate = new Date();
      file.name = path.split("/").slice(-1)[0];
      uploadFile(file, this.state.dir, file.name);
    }

    this.setState({
      uploading: false,
      uploadingErr: null,
      copyTasks: [],
      multipleSelects: [],
    });
    this.getDirectoryEntries(this.state.dir);
  };

  handleCreateFolder = () => {
    const { dir, newFolderName } = this.state;

    createDirectory(dir, newFolderName, (res) => {
      this.setState({ anchorNewFolder: null });
      this.getDirectoryEntries(this.state.dir);
    });
  };

  handleDeleteEntry = async () => {
    const { selectedEntry } = this.state;
    if (selectedEntry) {
      this.setState({ deleting: true, deleteErr: null });
      let res = await deleteEntry(selectedEntry.path);
      if (!res) {
        this.setState({ deleting: false, deleteErr: "delete failed" });
        return;
      }
      this.setState({
        deleting: false,
        deleteErr: null,
        selectedEntry: null,
        anchorDeleteEntry: null,
      });

      this.getDirectoryEntries(this.state.dir);
    }
  };

  handleEntrySelected = (item) => {
    this.setState({ selectedEntry: item });
    if (!item.is_directory) {
      this.getFileMetadata(item.name);
      this.setState({ newFilename: item.name, multipleSelects: [item.path] });
    }
  };

  handleEntryDoubleClick = (item) => {
    if (item.is_directory) {
      console.log("enter to ", item.path);
      this.getDirectoryEntries(item.path.replace(/\/+/g, "/"));
    }
  };

  // handleRename = () => {
  //   const { selectedEntry, newFilename } = this.state;
  //   const { mediaLibrary } = this.props;
  //   if (!newFilename || newFilename === "") return;
  //   const originPath = selectedEntry.path;
  //   const newPath = selectedEntry.path.replace(selectedEntry.name, newFilename);
  //   console.log(originPath, newPath)
  //   this.props.action_rename_file_entry(originPath, newPath, mediaLibrary.dir);
  //   // this.setState({ selectedEntry: null });
  // }

  handleChangeCredit = () => {
    const { metadata, selectedEntry } = this.state;
    const { credit } = metadata;
    if (credit === "") return;
    this.props.action_set_media_credit(selectedEntry.name, credit);
  };

  _renderFileDetails = () => {
    const { selectedEntry, newFilename, metadata } = this.state;
    if (!selectedEntry || selectedEntry.is_directory) return null;
    return (
      <FileDetailPanel
        selectedEntry={selectedEntry}
        newFilename={newFilename}
        metadata={metadata}
        onEditClicked={() => {
          this.setState({
            bEditDialogOpened: true,
            editUrl: `${UPLOADED_MEDIA_URL}${selectedEntry.path}`,
          });
        }}
      />
    );
  };

  _renderFileToolbar = () => {
    const { dir, multipleSelects, copyTasks } = this.state;

    return (
      <div style={{ textAlign: "right", whiteSpace: "nowrap" }}>
        <Tooltip title="Refresh">
          <IconButton onClick={() => this.getDirectoryEntries(dir)} size="large">
            <RefreshIcon />
          </IconButton>
        </Tooltip>
        {Array.isArray(multipleSelects) && multipleSelects.length > 0 ? (
          <Tooltip title="Copy">
            <IconButton
              onClick={() => this.setState({ copyTasks: [...multipleSelects] })}
              size="large">
              <FileCopy />
            </IconButton>
          </Tooltip>
        ) : null}
        {Array.isArray(copyTasks) && copyTasks.length > 0 ? (
          <Tooltip title="Paste">
            <IconButton onClick={this.handleCopyPaste} size="large">
              <AssignmentTurnedIn />
            </IconButton>
          </Tooltip>
        ) : null}
        <Tooltip title="Create Folder">
          <IconButton
            onClick={(e) => this.setState({ anchorNewFolder: e.currentTarget })}
            size="large">
            <CreateNewFolderIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Upload Image">
          <IconButton
            onClick={() =>
              this.setState({ bEditDialogOpened: true, editUrl: null })
            }
            size="large">
            <PublishIcon />
          </IconButton>
        </Tooltip>
        {this.state.selectedEntry ? (
          <Tooltip title="Delete">
            <IconButton
              onClick={(e) =>
                this.setState({ anchorDeleteEntry: e.currentTarget })
              }
              size="large">
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : null}
        <Popover
          anchorEl={this.state.anchorNewFolder}
          open={Boolean(this.state.anchorNewFolder)}
          onClose={() => this.setState({ anchorNewFolder: null })}
        >
          <div style={{ padding: "1rem" }}>
            <Input
              margin="dense"
              inputProps={{
                placeholder: "New Folder Name...",
              }}
              style={{ marginRight: "1rem" }}
              value={this.state.newFolderName}
              onChange={(e) => this.setState({ newFolderName: e.target.value })}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleCreateFolder}
            >
              Create
            </Button>
          </div>
        </Popover>
        <Popover
          anchorEl={this.state.anchorDeleteEntry}
          open={Boolean(this.state.anchorDeleteEntry)}
          onClose={() => this.setState({ anchorDeleteEntry: null })}
        >
          <div style={{ padding: "1rem" }}>
            <Typography variant="body1">
              Are you want to delete this entry?
            </Typography>
            <Button
              variant="contained"
              style={{ marginRight: "1rem" }}
              onClick={() => this.setState({ anchorDeleteEntry: null })}>
              No
            </Button>
            <Button
              variant="contained"
              color="secondary"
              style={{ marginRight: "1rem" }}
              onClick={this.handleDeleteEntry}
            >
              Yes
            </Button>
          </div>
        </Popover>
      </div>
    );
  };

  _getDirList = (dir) => {
    if (typeof dir !== "string") return [];
    return dir.split("/");
  };

  _renderCurrentDir = () => {
    let { dir } = this.state;
    console.log("dir", dir);
    if (!dir) dir = "";
    dir = dir.replace(/\/+/g, "/");

    let dirList = this._getDirList(dir);
    dirList = dirList.map((item) => {
      return { name: item };
    });
    let path = "";
    for (var item of dirList) {
      path += `/${item.name}`;
      item.path = path;
    }

    return (
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<NavigateNext fontSize="small" />}
      >
        {dirList.map((item, index) => {
          return (
            <Typography
              key={index}
              variant="subtitle1"
              color={
                index === dirList.length - 1 ? "textPrimary" : "textSecondary"
              }
              style={{ cursor: "pointer", display: "flex" }}
              onClick={() => {
                index < dirList.length - 1 &&
                  this.getDirectoryEntries(item.path.replace(/\/+/g, "/"));
              }}
            >
              {index === 0 ? <HomeIcon /> : item.name}
            </Typography>
          );
        })}
      </Breadcrumbs>
    );
  };

  render() {
    const {
      loading,
      uploading,
      uploadingErr,
      deleting,
      err,
      entries,
      bEditDialogOpened,
      editUrl,
    } = this.state;
    const { lang } = this.props;

    return (
      <Wrapper style={{ padding: 0 }}>
        <Paper style={{ padding: 10 }}>
          <div style={{ position: "relative", height: "calc(100vh - 132px)" }}>
            <SplitPane split="vertical" defaultSize={1000}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {this._renderCurrentDir()}
                  {this._renderFileToolbar()}
                </div>
                <FileBrowser
                  lang={lang.currentLanguage}
                  loading={loading | uploading | deleting}
                  data={entries}
                  error={err}
                  handleUpload={this.handleBulkUpload}
                  onMultipleSelected={(multipleSelects) =>
                    this.setState({ multipleSelects })
                  }
                  handleClickItem={this.handleEntrySelected}
                  handleDoubleClickItem={this.handleEntryDoubleClick}
                />
              </div>
              {this._renderFileDetails()}
            </SplitPane>
          </div>
        </Paper>
        {bEditDialogOpened ? (
          <UploadImageDialog
            editUrl={editUrl}
            editMode={Boolean(editUrl)}
            uploadError={uploadingErr}
            uploadedImage={null}
            handleUpload={this.handleUpload}
            onClose={() => this.setState({ bEditDialogOpened: false })}
          />
        ) : null}
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.lang,
  };
};

const matchDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(mediaLibraryTable);
